import Vue from "vue";
import VueRouter from "vue-router";

// ============================== Start Views ==============================
// Home
import Home from "../views/Home.vue";

// ********** Children
import HomePage from "../views/children/HomePage.vue";

// ========== Start Profiles ==========

// ========== End Profiles ==========

// ============================== START:: CRUDS ==============================

// ******* Start Vehicles *******
import VehiclesHome from "../views/children/CRUDS/Vehicles/Home.vue";
// Show All
import AllVehicles from "../views/children/CRUDS/Vehicles/ShowAll.vue";
// Show Single
import VehicleShow from "../views/children/CRUDS/Vehicles/Show.vue";
// Add/Edit
import VehicleForm from "../views/children/CRUDS/Vehicles/Form.vue";
// ******* End Vehicles *******

// ******* Start clients *******
// import ClientsHome from "../views/children/CRUDS/clients/Home.vue";
// // Show All
// import AllClients from "../views/children/CRUDS/clients/ShowAll.vue";
// // Show Single
// import ClientShow from "../views/children/CRUDS/clients/Show.vue";
// // Add/Edit
// import ClientForm from "../views/children/CRUDS/clients/Form.vue";
// ******* End clients *******

// ============================== START:: CRUDS ==============================

// ========== Start:: Static Screens ==========
import StaticScreens from "../views/children/StaticScreens/Home.vue";
// ========== End:: Static Screens ==========

// ========== Start:: Settings ==========
// *********** ABOUT
import AboutUsHome from "../views/children/Settings/AboutUs/Home.vue";
// Show All
import AllAboutUs from "../views/children/Settings/AboutUs/ShowAll.vue";
// Add/Edit
import AboutUsForm from "../views/children/Settings/AboutUs/Form.vue";

// *********** Terms
import TermsHome from "../views/children/Settings/Terms/Home.vue";
// Show All
import AllTerms from "../views/children/Settings/Terms/ShowAll.vue";
// Add/Edit
import TermsForm from "../views/children/Settings/Terms/Form.vue";

// *********** Policy
import PolicyHome from "../views/children/Settings/Policy/Home.vue";
// Show All
import AllPolicy from "../views/children/Settings/Policy/ShowAll.vue";
// Add/Edit
import PolicyForm from "../views/children/Settings/Policy/Form.vue";

// ========== End:: Settings ==========

// ========== Start:: Reference ==========
import Reference from "../Reference/Reference.vue";
// ========== End:: Reference ==========

// ********** Auth
import Login from "../views/Auth/Login.vue";

// ********** NotFound
import NotFound from "../views/NotFound.vue";
// ============================== End Views ==============================
// ******* Start Contact Messages *******
import ContactMessagesHome from '../views/children/CRUDS/ContactMessages/Home.vue'
// Show All
import AllContactMessages from '../views/children/CRUDS/ContactMessages/ShowAll.vue'
// Show Single
import ContactMessageShow from '../views/children/CRUDS/ContactMessages/Show.vue'
// ******* End Contact Messages *******

// Vuex store
import store from "../store/index";
let router = null;
window.rootRouter = router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    // Main
    {
      path: "/",
      component: Home,
      children: [
        {
          path: "/",
          name: "HomePage",
          component: HomePage,
        },

        // ============================== Start CRUDS ==============================
        // ******* Start Countries *******
        {
          path: "/countries",
          component: () => import("../views/children/CRUDS/Countries/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllCountries",
              component: () =>
                import("../views/children/CRUDS/Countries/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "CountryShow",
              component: () =>
                import("../views/children/CRUDS/Countries/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "CountryEdit",
              component: () =>
                import("../views/children/CRUDS/Countries/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "CountryAdd",
              component: () =>
                import("../views/children/CRUDS/Countries/Form.vue"),
            },
          ],
        },
        // ******* End Countries *******
        // ******* Start agents *******
        {
          path: "/admins",
          component: () => import("@/views/children/CRUDS/Admins/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllAdmins",
              component: () =>
                import("@/views/children/CRUDS/Admins/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "AdminShow",
              component: () => import("@/views/children/CRUDS/Admins/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "AdminEdit",
              component: () => import("@/views/children/CRUDS/Admins/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "AdminAdd",
              component: () => import("@/views/children/CRUDS/Admins/Form.vue"),
            },
          ],
        },
        {
          path: "/clients",
          component: () => import("@/views/children/CRUDS/clients/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllClients",
              component: () =>
                import("@/views/children/CRUDS/clients/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "ClientShow",
              component: () => import("@/views/children/CRUDS/clients/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "ClientEdit",
              component: () => import("@/views/children/CRUDS/clients/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "ClientAdd",
              component: () => import("@/views/children/CRUDS/clients/Form.vue"),
            },
          ],
        },
        // ******* End agents *******
        // ******* Start notifications *******
        {
          path: "/notifications",
          component: () =>
            import("@/views/children/CRUDS/notifications/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "all-notifications",
              component: () =>
                import("@/views/children/CRUDS/notifications/ShowAll.vue"),
            },
            // Show Single
            {
              path: "add",
              name: "add-notification",
              component: () =>
                import("@/views/children/CRUDS/notifications/Form.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "show-notification",
              component: () =>
                import("@/views/children/CRUDS/notifications/Show.vue"),
              props: true,
            },
          ],
        },
        // ******* End notifications *******

        // ******* Start Vehicles *******
        {
          path: "/vehicles",
          component: VehiclesHome,
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllVehicles",
              component: AllVehicles,
            },
            // Show Single
            {
              path: "show/:id",
              name: "VehicleShow",
              component: VehicleShow,
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "VehicleEdit",
              component: VehicleForm,
              props: true,
            },
            // Add
            {
              path: "add",
              name: "VehicleAdd",
              component: VehicleForm,
            },
          ],
        },
        // ******* End Vehicles *******
        // ******* Start Contact Messages *******
        {
          path: '/contacts',
          component: ContactMessagesHome,
          children: [
            // Show All
            {
              path: 'show-all',
              name: 'AllContactMessages',
              component: AllContactMessages,
            },
            // Show Single
            {
              path: 'show/:id',
              name: 'ContactMessageShow',
              component: ContactMessageShow,
              props: true,
            },
          ],
        },
        // ******* End Contact Messages *******
        // ******* Start Vehicle Model *******
        {
          path: "/accessorys",
          component: () =>
            import("../views/children/CRUDS/Accessorys/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "Allaccessorys",
              component: () =>
                import("../views/children/CRUDS/Accessorys/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "accessorysshow",
              component: () =>
                import("../views/children/CRUDS/Accessorys/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "accessorysEdit",
              component: () =>
                import("../views/children/CRUDS/Accessorys/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "accessorysAdd",
              component: () =>
                import("../views/children/CRUDS/Accessorys/Form.vue"),
            },
          ],
        },
        // ******* End Vehicle Model *******
        // ******* Start  Permission *******
        {
          path: "/permissions",
          component: () =>
            import("@/views/children/CRUDS/Permissions/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllPermissions",
              component: () =>
                import("@/views/children/CRUDS/Permissions/ShowAll.vue"),
            },
            // Show Single

            // Edit
            {
              path: "edit/:id",
              name: "EditPermission",
              component: () =>
                import("@/views/children/CRUDS/Permissions/Form.vue"),
              props: true,
            },
            // Edit
            {
              path: "add",
              name: "AddPermission",
              component: () =>
                import("@/views/children/CRUDS/Permissions/Form.vue"),
            },
          ],
        },
        // ******* End  Permission *******
        // ******* Start  permissions-labels *******
        {
          path: "/permission-labels",
          component: () =>
            import("@/views/children/CRUDS/PermissionLabels/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "all-permission-labels",
              component: () =>
                import("@/views/children/CRUDS/PermissionLabels/ShowAll.vue"),
            },
            // Show Single

            // Edit
            {
              path: "edit/:id",
              name: "edit-permission-label",
              component: () =>
                import("@/views/children/CRUDS/PermissionLabels/Form.vue"),
              props: true,
            },
            // Edit
            {
              path: "add",
              name: "add-permission-label",
              component: () =>
                import("@/views/children/CRUDS/PermissionLabels/Form.vue"),
            },
          ],
        },
        // ******* End  roles *******
        // ******* Start  brands *******
        {
          path: "/brands",
          component: () => import("@/views/children/CRUDS/Brand/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "all-brand",
              component: () =>
                import("@/views/children/CRUDS/Brand/ShowAll.vue"),
            },
            // Show Single

            // Edit
            {
              path: "edit/:id",
              name: "edit-brand",
              component: () => import("@/views/children/CRUDS/Brand/Form.vue"),
              props: true,
            },
            // Edit
            {
              path: "add",
              name: "add-brand",
              component: () => import("@/views/children/CRUDS/Brand/Form.vue"),
            },
          ],
        },
        // ******* End  brands *******

        // ******* Start  Sliders *******
        {
          path: "/sliders",
          component: () => import("@/views/children/CRUDS/Slider/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "all-slider",
              component: () =>
                import("@/views/children/CRUDS/Slider/ShowAll.vue"),
            },
            // Show Single

            // Edit
            {
              path: "edit/:id",
              name: "edit-slider",
              component: () => import("@/views/children/CRUDS/Slider/Form.vue"),
              props: true,
            },
            // Edit
            {
              path: "add",
              name: "add-slider",
              component: () => import("@/views/children/CRUDS/Slider/Form.vue"),
            },
          ],
        },
        // ******* End  sliders *******
        // ******* Start  details *******
        {
          path: "/details",
          component: () => import("@/views/children/CRUDS/Detail/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "all-detail",
              component: () =>
                import("@/views/children/CRUDS/Detail/ShowAll.vue"),
            },
            // Show Single

            // Edit
            {
              path: "edit/:id",
              name: "edit-detail",
              component: () => import("@/views/children/CRUDS/Detail/Form.vue"),
              props: true,
            },
            // Edit
            {
              path: "add",
              name: "add-detail",
              component: () => import("@/views/children/CRUDS/Detail/Form.vue"),
            },
          ],
        },
        // ******* End  details *******
        // ******* Start  specifications *******
        {
          path: "/specifications",
          component: () =>
            import("@/views/children/CRUDS/Specification/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "all-specification",
              component: () =>
                import("@/views/children/CRUDS/Specification/ShowAll.vue"),
            },
            // Show Single

            // Edit
            {
              path: "edit/:id",
              name: "edit-specification",
              component: () =>
                import("@/views/children/CRUDS/Specification/Form.vue"),
              props: true,
            },
            // Edit
            {
              path: "add",
              name: "add-specification",
              component: () =>
                import("@/views/children/CRUDS/Specification/Form.vue"),
            },
          ],
        },
        // ******* End  specifications *******

        // ******* Start  brand_models *******
        {
          path: "/brand_models",
          component: () => import("@/views/children/CRUDS/BrandModel/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "all-brand_model",
              component: () =>
                import("@/views/children/CRUDS/BrandModel/ShowAll.vue"),
            },
            // Show Single

            // Edit
            {
              path: "edit/:id",
              name: "edit-brand_model",
              component: () =>
                import("@/views/children/CRUDS/BrandModel/Form.vue"),
              props: true,
            },
            // Edit
            {
              path: "add",
              name: "add-brand_model",
              component: () =>
                import("@/views/children/CRUDS/BrandModel/Form.vue"),
            },
          ],
        },
        // ******* End  brand_models *******
        // ******* Start  categories *******
        {
          path: "/categories",
          component: () => import("@/views/children/CRUDS/Categories/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "all-category",
              component: () =>
                import("@/views/children/CRUDS/Categories/ShowAll.vue"),
            },
            // Show Single

            // Edit
            {
              path: "edit/:id",
              name: "edit-category",
              component: () =>
                import("@/views/children/CRUDS/Categories/Form.vue"),
              props: true,
            },
            // Edit
            {
              path: "add",
              name: "add-category",
              component: () =>
                import("@/views/children/CRUDS/Categories/Form.vue"),
            },
          ],
        },
        // ******* End  categories *******
        // ******* Start  categories *******
        {
          path: "/vehicle-type",
          component: () =>
            import("@/views/children/CRUDS/VehiclesType/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "all-category",
              component: () =>
                import("@/views/children/CRUDS/VehiclesType/ShowAll.vue"),
            },
            // Show Single

            // Edit
            {
              path: "edit/:id",
              name: "edit-category",
              component: () =>
                import("@/views/children/CRUDS/VehiclesType/Form.vue"),
              props: true,
            },
            // Edit
            {
              path: "add",
              name: "add-category",
              component: () =>
                import("@/views/children/CRUDS/VehiclesType/Form.vue"),
            },
          ],
        },
        // ******* End  categories *******
        // ******* Start  roles *******
        {
          path: "/roles",
          component: () => import("@/views/children/CRUDS/Roles/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "all-roles",
              component: () =>
                import("@/views/children/CRUDS/Roles/ShowAll.vue"),
            },
            // Show Single

            // Edit
            {
              path: "edit/:id",
              name: "edit-role",
              component: () => import("@/views/children/CRUDS/Roles/Form.vue"),
              props: true,
            },
            // Edit
            {
              path: "add",
              name: "add-role",
              component: () => import("@/views/children/CRUDS/Roles/Form.vue"),
            },
          ],
        },
        // ******* End  permissions-categories *******
        // ******* Start  permissions-categories *******
        {
          path: "/permission-categories",
          component: () =>
            import("@/views/children/CRUDS/PermissionCategory/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "all-permission-category",
              component: () =>
                import("@/views/children/CRUDS/PermissionCategory/ShowAll.vue"),
            },
            // Show Single

            // Edit
            {
              path: "edit/:id",
              name: "edit-permission-category",
              component: () =>
                import("@/views/children/CRUDS/PermissionCategory/Form.vue"),
              props: true,
            },
            // Edit
            {
              path: "add",
              name: "add-permission-category",
              component: () =>
                import("@/views/children/CRUDS/PermissionCategory/Form.vue"),
            },
          ],
        },
        // ******* End  permissions-categories *******

        // ******* End partners *******
        {
          path: "/ask-for-price",
          name: "AskForPrice",
          component: () =>
            import("../views/children/CRUDS/askForPrice/index.vue"),
        },
        // ============================== End CRUDS ==============================

        // ========== Start StaticScreens ==========
        {
          path: "/static-screens",
          name: StaticScreens,
          component: StaticScreens,
        },
        // ========== End StaticScreens ==========
        // ========== Start Settings ==========
        // ***** Anout Us
        {
          path: "/about",
          component: AboutUsHome,
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllAboutUs",
              component: AllAboutUs,
            },
            // Edit
            {
              path: "edit/:id",
              name: "AboutUsEdit",
              component: AboutUsForm,
              props: true,
            },
            // Add
            {
              path: "add",
              name: "AboutUsAdd",
              props: true,
              component: AboutUsForm,
            },
          ],
        },
        // ***** Faq
        {
          path: "/faqs",
          component: () => import("@/views/children/Settings/Faq/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllFaqs",
              component: () =>
                import("@/views/children/Settings/Faq/ShowAll.vue"),
            },
            // Edit
            {
              path: "edit/:id",
              name: "editAdd",
              component: () => import("@/views/children/Settings/Faq/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "faqAdd",
              component: () => import("@/views/children/Settings/Faq/Form.vue"),
            },
          ],
        },

        // ***** Terms
        {
          path: "/terms",
          component: TermsHome,
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllTerms",
              component: AllTerms,
            },
            // Edit
            {
              path: "edit/:id",
              name: "TermsEdit",
              component: TermsForm,
              props: true,
            },
            // Add
            {
              path: "add",
              name: "TermsAdd",
              component: TermsForm,
            },
          ],
        },

        // ***** Policy
        {
          path: "/policy",
          component: PolicyHome,
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllPolicy",
              component: AllPolicy,
            },
            // Edit
            {
              path: "edit/:id",
              name: "PolicyEdit",
              component: PolicyForm,
              props: true,
            },
            // Add
            {
              path: "add",
              name: "PolicyAdd",
              component: PolicyForm,
            },
          ],
        },

        // ***** Contact
        {
          path: "/settings",
          component: () => import("../views/children/Settings/Home.vue"),
          children: [
            {
              path: "",
              name: "mainSettings",
              component: () => import("../views/children/Settings/General.vue"),
            },
            {
              path: "social",
              name: "socialSettings",
              component: () => import("../views/children/Settings/Social.vue"),
            },
            {
              path: "sms",
              name: "sms",
              component: () =>
                import("../views/children/Settings/SmsServices.vue"),
            },
            {
              path: "order-setting",
              name: "order-setting",
              component: () => import("../views/children/Settings/Orders.vue"),
            },
            {
              path: "app-links",
              name: "app-links",
              component: () =>
                import("../views/children/Settings/AppLinks.vue"),
            },
            {
              path: "about",
              name: "about",
              component: () =>
                import("../views/children/Settings/About.vue"),
            },
            {
              path: "terms",
              name: "terms",
              component: () =>
                import("../views/children/Settings/Terms.vue"),
            },
            {
              path: "policy",
              name: "policy",
              component: () =>
                import("../views/children/Settings/Policy.vue"),
            },
          ],
        },
        // ========== End Settings ==========

        // ========== Start Profiles ==========
        {
          path: "/profile",

          component: () => import("@/views/children/adminProfile/Home.vue"),
          children: [
            {
              path: "show",
              name: "showProfile",
              component: () => import("@/views/children/adminProfile/Show.vue"),
            },
            {
              path: "edit",
              name: "editProfile",
              component: () => import("@/views/children/adminProfile/Form.vue"),
            },
            {
              path: "password",
              name: "changePassword",
              component: () =>
                import("@/views/children/adminProfile/ChangePassword.vue"),
            },
          ],
        },
        // ========== End Profiles ==========

        // ========== Start Reference==========
        {
          path: "/reference",
          name: "Reference",
          component: Reference,
        },
        // ========== End Reference ==========

        // ========== End Chat ==========

        // ========== Start DriversTracking ==========
        // {
        //   path: '/drivers_tracking',
        //   name: 'DriversTracking',
        //   component: DriversTracking,
        // },
        // ========== End DriversTracking ==========
      ],
    },
    {
      path: "/permission-required",
      name: "permission-required",
      component: () => import("../views/PermissionRequired.vue"),
    },

    //  =========== Start Redirects ===============
    {
      path: "/countries",

      redirect: () => {
        return { path: "/countries/show-all" };
      },
    },
    {
      path: "/about",

      redirect: () => {
        return { path: "/about/show-all" };
      },
    },
    {
      path: "/terms",

      redirect: () => {
        return { path: "/terms/show-all" };
      },
    },
    {
      path: "/privacy",

      redirect: () => {
        return { path: "/privacy/show-all" };
      },
    },
    {
      path: "/about/add",

      redirect: () => {
        return { path: "/about/show-all" };
      },
    },
    {
      path: "/terms/add",

      redirect: () => {
        return { path: "/terms/show-all" };
      },
    },
    {
      path: "/privacy/add",

      redirect: () => {
        return { path: "/privacy/show-all" };
      },
    },
    //  =========== End  Redirects ===============
    // Auth
    {
      path: "/login",
      name: "Login",
      component: Login,
    },

    // NotFound
    { path: "/:notFound(.*)", name: "NotFound", component: NotFound },
  ],
});

const TOKEN = store.getters["auth_module/currentUser"].token;

router.beforeEach((to, _2, next) => {
  if (to.name !== "Login" && !TOKEN) {
    next({ name: "Login" });
  } else if (to.name == "Login" && TOKEN) {
    next("/");
  } else {
    next();
  }
});

Vue.use(VueRouter);
export default router;
